import { createRoutine } from 'redux-saga-routines';

export const fetchScoreSettings = createRoutine('FETCH_SCORE_SETTINGS');

export const saveScoreSettings = createRoutine('SAVE_SCORE_SETTINGS');

export const reorderScoreSettings = createRoutine('REORDER_SCORE_SETTINGS');

export const deleteScoreSettings = createRoutine('DELETE_SCORE_SETTINGS');

export const fetchCriteriaSettings = createRoutine('FETCH_CRITERIA_SETTINGS');

export const saveCriteriaSettings = createRoutine('SAVE_CRITERIA_SETTINGS');

export const fetchHealthBreakdownDataByEventLevelId = createRoutine(
  'FETCH_HEALTH_BREAKDOWN_DATA_BY_ENTITY_LEVEL_ID'
);
